import { useCallback } from 'react';

import { CurrenciesShortHand } from '@/constants/currencies';

export const useGetCurrencyIcon = () => {
  return useCallback((currencyId: string | null | undefined) => {
    return currencyId ? (CurrenciesShortHand[currencyId] ?? null) : null;
  }, []);
};
